export default __webpack_public_path__ + "static/media/Renew.93f19d51.svg";